<template>
	<v-dialog v-model="dialog" persistent max-width="600px">
		<v-card v-if="asset">
			<v-toolbar flat dense>
				<v-toolbar-title class="subheading">Assign Asset</v-toolbar-title>
			</v-toolbar>

			<v-card-text>
				<v-select v-model="employeeSelected" prepend-icon="person" :items="employees" :error-messages="employeeIdErrors" item-text="fullName" return-object :label="$term('employee', { case: 'title' })" required></v-select>

				<v-textarea v-model="form.notes" auto-grow rows="3" box label="Notes"></v-textarea>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn flat @click="onCloseDialogClick">Cancel</v-btn>
				<v-btn flat color="primary" :loading="isSaving" :disabled="isSaving || !form.employeeId" @click="onSaveClick">
					Assign
					<span slot="loader">Assigning...</span>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';

	export default {
		props: {
			dialog: {
				required: true
			},
			asset: {
				type: Object,
				default: null
			},
			employeeId: {
				type: String,
				required: false
			},
			isSaving: {
				type: Boolean,
				required: false
			}
		},
		data() {
			return {
				form: {
					employeeId: this.employeeId,
					notes: null
				}
			};
		},
		computed: {
			...mapGetters({
				employees: 'employees/employeesMiniActiveOnly'
			}),
			employeeIdErrors() {
				const errors = [];
				if (!this.$v.form.employeeId.$dirty) return errors;
				!this.$v.form.employeeId.required && errors.push(`${this.$term('employee', { case: 'title' })} is required.`);
				return errors;
			},
			employeeSelected: {
				get() {
					return this.employees.find(x => x.id === this.form.employeeId);
				},
				set(val) {
					this.form.employeeId = val.id
				}
			}
		},
		mixins: [validationMixin],
		validations: {
			form: {
				employeeId: { required }
			}
		},
		methods: {
			onCloseDialogClick() {
				this.resetForm();
				this.$emit('closeDialog');
			},
			onSaveClick() {
				this.$emit('onSave', this.form);
			},
			resetForm() {
				this.form = {
					employeeId: this.employeeId,
					notes: null
				}
			}
		}
	};
</script>
